import React, { useState, useEffect } from 'react';
import './ChatSafetyOverview.css';

const ChatSafetyOverview = ({ interval, apiBaseUrl }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSafetyOverview();
  }, [interval]);

  const fetchSafetyOverview = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await fetch(
        `${apiBaseUrl}/chat_safety/overview/${interval}`
      );
      
      if (!response.ok) {
        throw new Error('Failed to fetch safety overview data');
      }
      
      const result = await response.json();
      setData(result);
    } catch (err) {
      console.error('Error fetching safety overview:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

 const formatNumber = (num) => {
  // Handle null or undefined
  if (num === null || num === undefined) return 'N/A';
  
  // Handle empty string
  if (num === '') return 'N/A';
  
  // Convert to number if it's a string
  const parsedNum = typeof num === 'string' ? parseFloat(num) : num;
  
  // Check if it's a valid number (including zero)
  if (isNaN(parsedNum)) return 'N/A';
  
  // Return formatted number (this will correctly show 0)
  return parsedNum.toLocaleString();
};

const formatPercentage = (num) => {
  // Handle null or undefined
  if (num === null || num === undefined) return 'N/A';
  
  // Handle empty string
  if (num === '') return 'N/A';
  
  // Convert to number if it's a string
  const parsedNum = typeof num === 'string' ? parseFloat(num) : num;
  
  // Check if it's a valid number (including zero)
  if (isNaN(parsedNum)) return 'N/A';
  
  // Return formatted percentage (this will correctly show 0%)
  return `${parsedNum}%`;
};

  if (loading) {
    return (
      <div className="safety-overview-loading">
        <div className="spinner"></div>
        <span>Loading safety overview...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="safety-overview-error">
        <p>Error loading data: {error}</p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="safety-overview-empty">
        <p>No safety data available for this period</p>
      </div>
    );
  }

  // FIX: Handle nested array response
const actualData = Array.isArray(data[0]) ? data[0] : data;

// Extract values from the array
const totalScanned = actualData[0];
const confirmedThreats = actualData[1];
const detectionRate = actualData[2];
const uniqueFlaggedUsers = actualData[3];

  return (
    <div className="safety-overview-container">
      <div className="safety-stat-card">
        <div className="stat-icon total-scanned">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
            <line x1="12" y1="22.08" x2="12" y2="12"></line>
          </svg>
        </div>
        <div className="stat-content">
          <div className="stat-value">{formatNumber(totalScanned)}</div>
          <div className="stat-label">Total Chats Scanned</div>
        </div>
      </div>

      <div className="safety-stat-card">
        <div className="stat-icon confirmed-threats">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </div>
        <div className="stat-content">
          <div className="stat-value threat">{formatNumber(confirmedThreats)}</div>
          <div className="stat-label">Confirmed Threats</div>
        </div>
      </div>

      <div className="safety-stat-card">
        <div className="stat-icon detection-rate">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
          </svg>
        </div>
        <div className="stat-content">
          <div className="stat-value">{formatPercentage(detectionRate)}</div>
          <div className="stat-label">Detection Rate</div>
        </div>
      </div>

      <div className="safety-stat-card">
        <div className="stat-icon flagged-users">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
        <div className="stat-content">
          <div className="stat-value">{formatNumber(uniqueFlaggedUsers)}</div>
          <div className="stat-label">Unique Users Flagged</div>
        </div>
      </div>
    </div>
  );
};

export default ChatSafetyOverview;